import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Collapse,
    CollapseProps,
    DatePicker,
    Divider,
    Form,
    Input,
    InputNumber,
    Radio,
    Row,
    Select,
    Spin
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import {
    getDivergenceNextPlanPeriod,
    getFrequencyType,
    getKrTrendingQuantitativeTypes,
    getQuantitativeEvaluationTypes
} from 'app/entities/common/common.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { PlantPeriodType } from 'app/shared/model/enum/plantPeriod.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { getInfo } from '../../../objective/objective.reducer';
import {
    createCopyEntity,
    getEntity,
    getCopyEntity,
    reset as resetQuantitative,
    updateCopyEntity,
    updateCopyEntityVer2
} from '../../kr-quantitative.reducer';
import ObjectiveKRRowSelection from 'app/entities/objective/form/view-row-selection/objective-kr';


type KrFormType = {
    onClose: (isReload?: boolean) => void;
    idObjective?: string;
    planPeriodIdSelected?: string;
    idKrBaseSelected?: string;
    krTypeRequest?: number;
    planPeriodType?: PlantPeriodType;
    handleChangeKRType: (value: KrTypes) => void;
    KrType: KrTypes;
    isEdit: boolean
    isReadOnly?: boolean;
    selectedPeriod?: number;
};

export const CopyKRQuantitative = ({ onClose, isEdit, isReadOnly, planPeriodIdSelected, idObjective, idKrBaseSelected, krTypeRequest, planPeriodType, handleChangeKRType, KrType, selectedPeriod }: KrFormType) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const isNew = idKrBaseSelected === undefined || idKrBaseSelected === null;
    const { id } = useParams();

    const krQuantitativeEntity = useAppSelector(state => state.krQuantitative.entity);
    const objectiveEntity = useAppSelector(state => state.objective.entity);
    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const updatingQuantitative = useAppSelector(state => state.krQuantitative.updating);
    const krQuantitativeUpdateSuccess = useAppSelector(state => state.krQuantitative.updateSuccess);
    const loadingQuantitative = useAppSelector(state => state.krQuantitative.loading);
    const filtersObjective = useAppSelector(state => state.filters.objective);

    // common data
    const employeeList = useAppSelector(state => state.common.personPositions);
    const frequencies = useAppSelector(state => state.common.frequencies);
    const krTypes = useAppSelector(state => state.common.krType);
    const krTrendingTypes = useAppSelector(state => state.common.krTrending);
    const quantitativeTypes = useAppSelector(state => state.common.quantitative);
    const associateTypes = useAppSelector(state => state.common.associates);
    const lesserPlanPeriodTypes = useAppSelector(state => state.common.nextLesserPlanPeriod);

    const [planPeriodSelected, setPlanPeriodSelected] = useState<any>();
    const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
    const [isSaveChange, setSaveChange] = useState(false);
    const [isOpenModal, setOpenModal] = useState(false);

    // define values for max, min dates
    const [mintDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();

    // form watcher data

    const krTypeValues = Form.useWatch('krType', form);
    const metricTypeValues = Form.useWatch('metricType', form);
    const planPeriodIdValues = Form.useWatch('planPeriodId', form);
    const evaluationMethodQuantitativeValue = Form.useWatch('evaluationMethodQuantitative', form);

    const metricValueFirstQuarterValues = Form.useWatch('metricValue-quarter-0', form);
    const metricValueSecondQuarterValues = Form.useWatch('metricValue-quarter-1', form);
    const metricValueThirdQuarterValues = Form.useWatch('metricValue-quarter-2', form);
    const metricValueFourthQuarterValues = Form.useWatch('metricValue-quarter-3', form);


    const metricValueFirstMonthFirstQuarterValues = Form.useWatch('metricValue-quarter-0-month-0', form);
    const metricValueSecondMonthFirstQuarterValues = Form.useWatch('metricValue-quarter-0-month-1', form);
    const metricValueThirdMonthFirstQuarterValues = Form.useWatch('metricValue-quarter-0-month-2', form);

    const metricValueFirstMonthSecondQuarterValues = Form.useWatch('metricValue-quarter-1-month-0', form);
    const metricValueSecondMonthSecondQuarterValues = Form.useWatch('metricValue-quarter-1-month-1', form);
    const metricValueThirdMonthSecondQuarterValues = Form.useWatch('metricValue-quarter-1-month-2', form);

    const metricValueFirstMonthThirdQuarterValues = Form.useWatch('metricValue-quarter-2-month-0', form);
    const metricValueSecondMonthThirdQuarterValues = Form.useWatch('metricValue-quarter-2-month-1', form);
    const metricValueThirdMonthThirdQuarterValues = Form.useWatch('metricValue-quarter-2-month-2', form);

    const metricValueFirstMonthFourthQuarterValues = Form.useWatch('metricValue-quarter-3-month-0', form);
    const metricValueSecondMonthFourthQuarterValues = Form.useWatch('metricValue-quarter-3-month-1', form);
    const metricValueThirdMonthFourthQuarterValues = Form.useWatch('metricValue-quarter-3-month-2', form);

    const yearPlanPeriodName = isNew ? lesserPlanPeriodTypes?.year?.name : krQuantitativeEntity?.year?.name;
    // define data collapse
    const items: CollapseProps['items'] = [
        {
            key: '1',
            label: 'Thông tin mục tiêu',
            children: (
                <Row>
                    <Col md={7}>
                        <Form.Item label="Lĩnh vực">
                            <Input className="w-100" value={objectiveEntity?.fieldName} disabled size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={7}>
                        <Form.Item label="Dự án">
                            <Input className="w-100" value={objectiveEntity?.name} disabled size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={8}>
                        <Form.Item label="Nhóm công việc">
                            <Input className="w-100" value={objectiveEntity?.workTypeName} disabled size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={24}>
                        <Form.Item label="Nội dung mục tiêu">
                            <TextArea disabled value={objectiveEntity?.purpose} placeholder="Nhập nội dung mục tiêu" size="large" />
                        </Form.Item>
                    </Col>
                    <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                        {`Thông tin chi tiết >`}
                    </span>
                </Row>
            ),
        },
    ];

    const handleClose = (isReload = undefined) => {
        form.resetFields();
        dispatch(resetQuantitative());
        onClose(isReload ?? isSaveChange);
    };

    useEffect(() => {
        innitData();
    }, []);

    useEffect(() => {
        form.validateFields([
            'metricValue-quarter-0-month-0', 'metricValue-quarter-0-month-1', 'metricValue-quarter-0-month-2',
        ]);
        if (krTypeValues === KrTypes.AccumulateQuantitative) {
            handleAutoAccumulate(
                'metricValue',
                metricValueFirstQuarterValues,
                metricValueSecondQuarterValues,
                metricValueThirdQuarterValues,
                metricValueFourthQuarterValues
            );
        }
    }, [metricValueFirstQuarterValues, metricValueSecondQuarterValues, metricValueThirdQuarterValues, metricValueFourthQuarterValues])

    useEffect(() => {
        form.validateFields([
            'metricValue-quarter-0-month-0', 'metricValue-quarter-0-month-1', 'metricValue-quarter-0-month-2',
        ]);
        if (krTypeValues === KrTypes.AccumulateQuantitative) {
            handleAutoAccumulate(
                'metricValue-quarter-0',
                metricValueFirstMonthFirstQuarterValues,
                metricValueSecondMonthFirstQuarterValues,
                metricValueThirdMonthFirstQuarterValues
            );
        }
    }, [metricValueFirstMonthFirstQuarterValues, metricValueSecondMonthFirstQuarterValues, metricValueThirdMonthFirstQuarterValues])

    useEffect(() => {
        if (krTypeValues === KrTypes.AccumulateQuantitative) {
            handleAutoAccumulate(
                'metricValue-quarter-1',
                metricValueFirstMonthSecondQuarterValues,
                metricValueSecondMonthSecondQuarterValues,
                metricValueThirdMonthSecondQuarterValues
            );
        }
    }, [metricValueFirstMonthSecondQuarterValues, metricValueSecondMonthSecondQuarterValues, metricValueThirdMonthSecondQuarterValues])

    useEffect(() => {
        if (krTypeValues === KrTypes.AccumulateQuantitative) {
            handleAutoAccumulate(
                'metricValue-quarter-2',
                metricValueFirstMonthThirdQuarterValues,
                metricValueSecondMonthThirdQuarterValues,
                metricValueThirdMonthThirdQuarterValues,
            );
        }
    }, [metricValueFirstMonthThirdQuarterValues, metricValueSecondMonthThirdQuarterValues, metricValueThirdMonthThirdQuarterValues])

    useEffect(() => {
        if (krTypeValues === KrTypes.AccumulateQuantitative) {
            handleAutoAccumulate(
                'metricValue-quarter-3',
                metricValueFirstMonthFourthQuarterValues,
                metricValueSecondMonthFourthQuarterValues,
                metricValueThirdMonthFourthQuarterValues
            );
        }
    }, [metricValueFirstMonthFourthQuarterValues, metricValueSecondMonthFourthQuarterValues, metricValueThirdMonthFourthQuarterValues])

    useEffect(() => {
        dispatch(getQuantitativeEvaluationTypes());
        dispatch(getKrTrendingQuantitativeTypes());
    }, []);

    useEffect(() => {
        form.setFieldsValue({ krType: KrType });
    }, [KrType]);

    useEffect(() => {
        if (planPeriodIdValues) {

            handleChangePlanPeriod(planPeriodIdValues);

        }
    }, [planPeriodIdValues]);

    useEffect(() => {
        if (evaluationMethodQuantitativeValue !== QuantitativeEvaluationType.SelfDefinition && metricTypeValues >= 0) {
            if (metricTypeValues === TrendingTypes.Above) {
                form.setFieldValue('evaluationMethodQuantitativeNote', 'Giá trị thực hiện / Giá trị cần đạt được');
            } else {
                form.setFieldValue('evaluationMethodQuantitativeNote', 'Giá trị cần đạt được / Giá trị thực hiện');
            }
        } else {
            form.setFieldValue('evaluationMethodQuantitativeNote', krQuantitativeEntity?.evaluationMethodQuantitativeNote ?? '');
        }
    }, [metricTypeValues, evaluationMethodQuantitativeValue])

    useEffect(() => {
        if ((krQuantitativeEntity) && !isNew) {
            const objectQuarter = {};
            const objectMonth = {};
            const entityCommon = { ...krQuantitativeEntity };
            let quarters = []
            let months = []
            if (krQuantitativeEntity?.quarters && krQuantitativeEntity?.quarters.length > 0) {
                quarters = krQuantitativeEntity?.quarters?.map((item: any, index) => {
                    if (item.quarter) {
                        return {
                            'metricValue-quarter': item.quarter.metricValue,
                        };
                    }
                });
                krQuantitativeEntity?.quarters?.map((item: any, index) => {
                    if (item.months && item.months.length > 0) {
                        {
                            months = months.concat(item.months.map((x: any) => {
                                if (x) {
                                    return {
                                        [`metricValue-quarter-${index}-month`]: x.metricValue,
                                    };
                                }
                            }));
                        }
                    }
                });
            }
            quarters?.forEach((item, index) => {
                if (item) {
                    Object.entries(item).forEach(([key, value]: any) => {
                        if (key.includes('startDate') || key.includes('dueDate')) {
                            objectQuarter[`${`${key}-${index}`}`] = dayjs(value);
                        } else {
                            objectQuarter[`${`${key}-${index}`}`] = value;
                        }
                    });
                }
            });

            const monthByQuarters = _.chunk(months, 3);
            monthByQuarters?.forEach((month) => {
                month.forEach((item, index) => {
                    Object.entries(item).forEach(([key, value]: any) => {
                        objectMonth[`${`${key}-${index}`}`] = value;
                    });
                })
            }
            );
            const entity = {
                ...entityCommon,
                tags: _.join(entityCommon.tags, ','),
                startDate: dayjs(entityCommon?.year?.startDate),
                dueDate: dayjs(entityCommon?.year?.dueDate),
                metricValue: entityCommon?.year?.metricValue,
                informEmails: entityCommon.raci?.informEmails,
                consultantIds: entityCommon.raci?.consultantIds,
                accountableId: entityCommon.raci?.accountableId,
                responsibleIds: entityCommon.raci?.responsibleIds,
                ...objectQuarter,
                ...objectMonth,
            };
            form.setFieldsValue(entity);
        }
    }, [krQuantitativeEntity]);

    const innitData = () => {
        dispatch(getInfo(id ?? idObjective));
        if (isNew) {
            form.resetFields();
        } else if (!isEdit) {
            dispatch(getCopyEntity({ idKrBaseSelected, planPeriodId: planPeriodIdSelected, okrVersion: filtersObjective?.okrVersion }));
        }
        else {
            dispatch(getEntity({ idKrBaseSelected, planPeriodId: planPeriodIdSelected }));
        }
    };

    const handleAutoAccumulate = (field: string, value: number | string = 0, value2: number = 0, value3: number = 0, value4: number = 0) => {
        const total = Number(value) + Number(value2) + Number(value3) + Number(value4);
        if (_.isInteger(total))
            form.setFieldsValue({ [field]: total })
        else form.setFieldsValue({ [field]: total.toFixed(2) })
    }

    // eslint-disable-next-line complexity
    const handleSubmit = values => {
        const {
            tags,
            contribution,
            informEmails,
            consultantIds,
            accountableId,
            responsibleIds,
            associateIds,
            evaluationMethods,
            krType,
            planPeriodId,
            frequencyId,
            accessIds,
            sendingNotification,
            startDate,
            dueDate,
            evaluationMethodQuantitative,
            evaluationMethodQuantitativeNote,
            name,
            unit,
            metricType,
            metricValue,
            alignCode,
            ...remainingValues
        } = values;
        let quarters = [];
        let months = [];
        // Khởi tạo mảng khóa
        const keys = Object.keys(remainingValues);

        // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
        const groupedKeys = _.chunk(keys, 1);
        // Separate arrays using lodash filter
        const monthArray = _.filter(groupedKeys, item => item && item[0] && item[0].includes('month'));
        const quarterArray = _.differenceWith(groupedKeys, monthArray, _.isEqual);
        // Tạo mảng mới từ các nhóm khóa
        quarters = _.map(quarterArray, group => {
            const mapper = _.map(group, key => {
                return remainingValues[key];
            });
            return _.zipObject(['metricValue'], mapper);
        });

        // Tạo mảng mới từ các nhóm khóa
        months = _.map(monthArray, group => {
            const mapper = _.map(group, key => {

                return remainingValues[key];
            });
            return _.zipObject(['metricValue'], mapper);
        });

        const monthByQuarters = _.chunk(months, 3);

        // Map lại dữ liệu theo quý/tháng một cách an toàn
        if (quarters && quarters.length > 0) {
            quarters = quarters.map((item, index) => {
                const quarterConfig = lesserPlanPeriodTypes?.quarters?.[index];
                const monthsOfQuarter = monthByQuarters[index] || [];

                return {
                    quarter: {
                        ...item,
                        planPeriodId: quarterConfig?.quarter?.id,
                        metricValue: item.metricValue,
                        startDate: quarterConfig?.quarter?.startDate,
                        dueDate: quarterConfig?.quarter?.endDate,
                    },
                    months: monthsOfQuarter.map((itemMonth, indexMonth) => {
                        const monthConfig = quarterConfig?.months?.[indexMonth];
                        return {
                            ...itemMonth,
                            planPeriodId: monthConfig?.id ?? "",
                            startDate: monthConfig?.startDate ?? null,
                            dueDate: monthConfig?.endDate ?? null,
                            metricValue: itemMonth.metricValue,
                        };
                    }),
                };
            });
        }
        const detailEntity = !isNew ? krQuantitativeEntity : undefined;

        const entity = {
            ...detailEntity,
            evaluationMethodQuantitative,
            evaluationMethodQuantitativeNote,
            krType,
            name,
            unit,
            metricType,
            startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
            dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
            accessIds,
            planPeriodId,
            frequencyId,
            sendingNotification,
            associateIds: associateIds ?? [],
            tags: _.split(tags, ','),
            contribution: percent(contribution),
            objectiveId: id ?? idObjective,
            raci: {
                informEmails: _.split(informEmails, ','),
                consultantIds,
                accountableId,
                responsibleIds,
            },
            quarters,
            year: {
                startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                metricValue,
                planPeriodId: lesserPlanPeriodTypes?.year.id
            },
        };
        if (isNew) {
            dispatch(createCopyEntity(entity)).then(res => {
                if (res && res.payload) {
                    handleClose(true);
                }
            });
        } else {
            dispatch(updateCopyEntityVer2(entity)).then(res => {
                if (res && res.payload) {
                    handleClose(true);
                }
            });
        }
    };

    const handleChangePlanPeriod = (planPeriod: string) => {
        dispatch(getFrequencyType(planPeriod));
        const planPeriodDetails = _.find(planPeriodList, o => o.id === planPeriod);
        if (planPeriodDetails) {
            if (isNew) {
                form.setFieldValue('startDate', dayjs(planPeriodDetails.startDate));
                form.setFieldValue('dueDate', dayjs(planPeriodDetails.endDate));
            }
            setPlanPeriodSelected(planPeriodDetails);
            setMinDate(planPeriodDetails.startDate);
            setMaxDate(planPeriodDetails.endDate);
        }
    };

    const quarterPlanPeriods = isNew ? lesserPlanPeriodTypes?.quarters : krQuantitativeEntity?.quarters;

    const handleMapperResultByPlanPeriod = () => {
        if (quarterPlanPeriods?.length > 0) {
            return quarterPlanPeriods?.map((item, index) => {
                return (
                    <>
                        <Col key={item?.quarter?.id} md={5}>
                            <Form.Item rules={[
                                KrType === KrTypes.AccumulateQuantitative ? {
                                    required: !metricValueFirstQuarterValues && !metricValueSecondQuarterValues && !metricValueThirdQuarterValues && !metricValueFourthQuarterValues,
                                    message: "Vui lòng nhập"
                                } : undefined
                            ]} label={`${item.quarter?.name}`} name={`metricValue-quarter-${index}`}>
                                <InputNumber disabled={krTypeValues === KrTypes.AccumulateQuantitative} step={0.01} precision={2} className='w-100' formatter={formatNumber} parser={parseNumber} placeholder={`Nhập chỉ tiêu quý ${item.quarter?.name}`} size="large" />
                            </Form.Item>
                            {handleMapperMonthByPlanPeriod(index)}
                        </Col>
                        <Col key={`quarter-${index}`} md={1} />
                    </>
                )
            });
        }
    };

    const handleMapperMonthByPlanPeriod = (index) => {
        if (quarterPlanPeriods?.[index]?.months?.length > 0) {
            return quarterPlanPeriods?.[index]?.months?.map((item, indexMonth) => {
                return (
                    <Row key={item.id}>
                        <Col key={item.id} md={24}>
                            <Form.Item rules={[
                                KrType === KrTypes.AccumulateQuantitative ? {
                                    required: !metricValueFirstMonthFirstQuarterValues && !metricValueSecondMonthFirstQuarterValues && !metricValueThirdMonthFirstQuarterValues,
                                    message: "Vui lòng nhập"
                                } : KrType === KrTypes.UnAccumulateQuantitative ?
                                    index === 0 ?
                                        {
                                            required: metricValueFirstQuarterValues &&
                                                !metricValueFirstMonthFirstQuarterValues &&
                                                !metricValueSecondMonthFirstQuarterValues &&
                                                !metricValueThirdMonthFirstQuarterValues,
                                            message: "Vui lòng nhập"
                                        } : undefined
                                    : undefined
                            ]} label={`${item.name}`} name={`metricValue-quarter-${index}-month-${indexMonth}`}>
                                <InputNumber step={0.01} precision={2} className='w-100' formatter={formatNumber} parser={parseNumber} placeholder={`Nhập chỉ tiêu tháng ${item.name}`} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>
                );
            });
        }
    };

    const handleEditObjective = () => {
        setIsOpenModalFormObjective(true);
    };

    const handleCloseModelObjective = (isReload = false) => {
        setIsOpenModalFormObjective(false);
    };

    const handleLesserPlanPeriod = async (planPeriodId: string) => {
        await dispatch(getDivergenceNextPlanPeriod(planPeriodId));
    };

    const handleNextKr = () => {
        form
            .validateFields()
            .then(values => {
                const {
                    tags,
                    contribution,
                    informEmails,
                    consultantIds,
                    accountableId,
                    responsibleIds,
                    associateIds,
                    evaluationMethods,
                    krType,
                    planPeriodId,
                    frequencyId,
                    accessIds,
                    sendingNotification,
                    purpose,
                    startDate,
                    dueDate,
                    evaluationMethodQuantitative,
                    evaluationMethodQuantitativeNote,
                    name,
                    unit,
                    metricType,
                    metricValue,
                    alignCode,
                    ...remainingValues
                } = values;
                let quarters = [];
                let months = [];
                // Khởi tạo mảng khóa
                const keys = Object.keys(remainingValues);

                // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
                const groupedKeys = _.chunk(keys, 1);
                // Separate arrays using lodash filter
                const monthArray = _.filter(groupedKeys, item => item && item[0] && item[0].includes('month'));
                const quarterArray = _.differenceWith(groupedKeys, monthArray, _.isEqual);
                // Tạo mảng mới từ các nhóm khóa
                quarters = _.map(quarterArray, group => {
                    const mapper = _.map(group, key => {
                        return remainingValues[key];
                    });
                    return _.zipObject(['metricValue'], mapper);
                });

                // Tạo mảng mới từ các nhóm khóa
                months = _.map(monthArray, group => {
                    const mapper = _.map(group, key => {

                        return remainingValues[key];
                    });
                    return _.zipObject(['metricValue'], mapper);
                });

                const monthByQuarters = _.chunk(months, 3);

                quarters = quarters.map((item, index) => {
                    return {
                        quarter: {
                            ...item,
                            planPeriodId: lesserPlanPeriodTypes?.quarters[index]?.quarter?.id,
                            metricValue: item.metricValue,
                            startDate: lesserPlanPeriodTypes?.quarters[index]?.quarter?.startDate,
                            dueDate: lesserPlanPeriodTypes?.quarters[index]?.quarter?.endDate,
                        },
                        months: monthByQuarters[index].map((itemMonth, indexMonth) => {
                            return {
                                ...itemMonth,
                                planPeriodId: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index].months[indexMonth].id : "",
                                startDate: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index]?.months[indexMonth].startDate : null,
                                dueDate: lesserPlanPeriodTypes?.quarters && lesserPlanPeriodTypes?.quarters[index] ? lesserPlanPeriodTypes?.quarters[index]?.months[indexMonth].endDate : null,
                                metricValue: itemMonth.metricValue,
                            };
                        })
                    };
                });
                const detailEntity = !isNew ? krQuantitativeEntity : undefined;

                const entity = {
                    ...detailEntity,
                    evaluationMethodQuantitative,
                    evaluationMethodQuantitativeNote,
                    krType,
                    name,
                    unit,
                    metricType,
                    startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                    dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                    accessIds,
                    planPeriodId,
                    frequencyId,
                    sendingNotification,
                    associateIds: associateIds ?? [],
                    tags: _.split(tags, ','),
                    contribution: percent(contribution),
                    objectiveId: id ?? idObjective,
                    raci: {
                        informEmails: _.split(informEmails, ','),
                        consultantIds,
                        accountableId,
                        responsibleIds,
                    },
                    quarters,
                    year: {
                        startDate: dayjs(startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                        dueDate: dayjs(dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                        metricValue,
                        planPeriodId: lesserPlanPeriodTypes?.year.id
                    },
                };
                dispatch(createCopyEntity(entity))
                    .then(res => {
                        if (res && res.payload) {
                            form.resetFields();
                            setSaveChange(true);
                        }
                    })
                    .catch(() => {
                        return;
                    });
            })
            .catch(() => {
                return;
            });
    };

    const handleCloseModal = (isUpdateValue = true, itemSelected = []) => {
        if (isUpdateValue) {
            form.setFieldsValue(
                {
                    alignCode: itemSelected.length > 0 ? `${_.join(itemSelected.map(x => x.code), " ,")}` : null,
                    associateIds: itemSelected.map(x => x.id)
                }
            );
        }
        setOpenModal(false)
    }

    const handleOpenModalViewRowSelection = () => {
        setOpenModal(true)
    }

    return (
        <Spin delay={300} spinning={loadingQuantitative}>
            <Container className="form">
                <Form
                    size="large"
                    form={form}
                    initialValues={{
                        sendingNotification: false,
                    }}
                    onFinish={handleSubmit}
                    layout="vertical"
                    disabled={isReadOnly}
                >
                    <Title level={3}>{isNew ? `Thêm mới` : `Cập nhật thông tin2`} KR</Title>

                    <Form.Item>
                        <Collapse items={items} />
                    </Form.Item>
                    <Row>
                        <Col md={3}>
                            <Form.Item
                                label="Kỳ kế hoạch"
                                initialValue={planPeriodIdSelected}
                                rules={[{ required: true, message: 'Hãy chọn kỳ kế hoạch' }]}
                                name="planPeriodId"
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    size="large"
                                    disabled={!isNew}
                                    filterOption={filterOption}
                                    options={planPeriodList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn kỳ kế hoạch"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={14}>
                            <Form.Item label="Mục tiêu, KR liên kết" name="associateIds">
                                <Row gutter={8} align="middle">
                                    <Col flex="auto">
                                        <Form.Item noStyle
                                            name={'alignCode'}>
                                            <Input
                                                readOnly
                                                size="large"
                                                placeholder="Chọn mục tiêu, KR liên kết"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Button
                                            className="primary"
                                            size="large"
                                            onClick={handleOpenModalViewRowSelection}
                                            icon={<PlusOutlined />}
                                        >
                                        </Button>
                                    </Col>
                                </Row>
                                {/* <Select
                                    allowClear
                                    showSearch
                                    mode="multiple"
                                    size="large"
                                    disabled={!isNew && planPeriodType === PlantPeriodType.Quarter}
                                    filterOption={filterOption}
                                    options={associateTypes}
                                    placeholder="Chọn mục tiêu, KR liên kết"
                                /> */}
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={5}>
                            <Form.Item
                                label="Loại KR"
                                rules={[{ required: true, message: 'Hãy chọn loại KR' }]}
                                name="krType"
                                initialValue={KrType}
                            >
                                <Select filterOption={filterOption} allowClear showSearch size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} onChange={handleChangeKRType} options={krTypes} placeholder="Chọn loại KR" />
                            </Form.Item>
                        </Col>
                    </Row>
                    {planPeriodSelected &&
                        <>
                            <Divider orientation="left">Kết quả cần đạt được</Divider>
                            <Row>
                                <Col md={11}>
                                    <Form.Item label="Tên chỉ tiêu" rules={[{ required: true, message: 'Hãy nhập Tên chỉ tiêu' }]} name={'name'}>
                                        <Input
                                            disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} placeholder="Nhập Tên chỉ tiêu" size="large" />
                                    </Form.Item>
                                </Col>
                                <Col md={1} />
                                <Col md={3}>
                                    <Form.Item label="Đơn vị tính" rules={[{ required: true, message: 'Hãy chọn đơn vị tính' }]} name="unit">
                                        <Input
                                            disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} placeholder={`Nhập đơn vị tính`} size="large" />
                                    </Form.Item>
                                </Col>
                                <Col md={1} />
                                <Col md={3}>
                                    <Form.Item initialValue={dayjs().startOf('year')} label="Ngày bắt đầu" rules={[{ required: true, message: 'Hãy chọn ngày bắt đầu' }]} name={'startDate'}>
                                        <DatePicker
                                            minDate={dayjs(mintDate)}
                                            maxDate={dayjs(maxDate)}
                                            className="w-100"
                                            size="large"
                                            disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                            format={APP_LOCAL_DATE_FORMAT}
                                            placeholder="Chọn ngày bắt đầu"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={1} />
                                <Col md={4}>
                                    <Form.Item
                                        initialValue={dayjs().endOf('year')}
                                        label="Thời hạn hoàn thành"
                                        rules={[{ required: true, message: 'Hãy chọn thời hạn hoàn thành' }]}
                                        name={'dueDate'}
                                    >
                                        <DatePicker
                                            minDate={dayjs(mintDate)}
                                            maxDate={dayjs(maxDate)}
                                            className="w-100"
                                            size="large"
                                            disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                            format={APP_LOCAL_DATE_FORMAT}
                                            placeholder="Chọn thời hạn hoàn thành"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    }
                    <Row>
                        <Col md={5}>
                            <Form.Item label="Xu hướng" rules={[{ required: true, message: 'Vui lòng chọn xu hướng' }]} name="metricType">
                                <Select
                                    filterOption={filterOption}
                                    allowClear
                                    showSearch
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    options={krTrendingTypes}
                                    placeholder="Chọn xu hướng"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={5}>
                            <Form.Item
                                label={_.upperFirst(`Chỉ tiêu ${yearPlanPeriodName ?? planPeriodSelected?.name ?? ''}`)}
                                rules={[{ required: true, message: 'Vui lòng nhập' }]}
                                name={'metricValue'}>
                                <InputNumber
                                    disabled={krTypeValues === KrTypes.AccumulateQuantitative || isReadOnly} className='w-100' formatter={formatNumber} parser={parseNumber} placeholder={`nhập chỉ tiêu ${planPeriodSelected ? planPeriodSelected.name : ''}`} size="large" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        {handleMapperResultByPlanPeriod()}
                    </Row>
                    <Row>
                        <Col md={3}>
                            <Form.Item
                                label="Tần suất báo cáo"
                                rules={[{ required: true, message: 'Hãy chọn tần suất báo cáo' }]}
                                name="frequencyId"
                            >
                                <Select
                                    filterOption={filterOption}
                                    allowClear
                                    showSearch
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    options={frequencies}
                                    placeholder="Chọn tần suất báo cáo"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={5}>
                            <Form.Item
                                label="Cách đánh giá tỷ lệ hoàn thành"
                                rules={[{ required: true, message: 'Hãy chọn cách đánh giá' }]}
                                name="evaluationMethodQuantitative"
                            >
                                <Radio.Group
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} className="d-grid" options={quantitativeTypes} />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={13} className="mt-4">
                            <Form.Item rules={[{ required: evaluationMethodQuantitativeValue === QuantitativeEvaluationType.SelfDefinition, message: "Vui lòng nhập nội dung định nghĩa" }]} name={'evaluationMethodQuantitativeNote'}>
                                {evaluationMethodQuantitativeValue >= 0 ? (
                                    <TextArea
                                        rows={1}
                                        disabled={
                                            (evaluationMethodQuantitativeValue !== QuantitativeEvaluationType.SelfDefinition)
                                            || (!isNew && planPeriodType === PlantPeriodType.Quarter
                                                || isReadOnly
                                            )}
                                        placeholder="Nhập nội dung định nghĩa"
                                        size="large"
                                    />
                                ) : undefined}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={7}>
                            <Form.Item
                                label="Người thực hiện chính (PIC)"
                                rules={[{ required: true, message: 'Hãy chọn người thực hiện chính' }]}
                                name="accountableId"
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    size="large"
                                    filterOption={filterOption}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn người thực hiện chính"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={7}>
                            <Form.Item label="Các bên tham gia thực hiện trực tiếp" name="responsibleIds">
                                <Select
                                    allowClear
                                    showSearch
                                    mode="multiple"
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    filterOption={filterOption}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn các bên tham gia thực hiện trực tiếp"
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={8}>
                            <Form.Item label="Các bên hỗ trợ" name="consultantIds">
                                <Select
                                    allowClear
                                    showSearch
                                    mode="multiple"
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    filterOption={filterOption}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                    placeholder="Chọn các bên hỗ trợ"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={7}>
                            <Form.Item label="Người nhận thông báo (cách nhau dấu phẩy)" name={'informEmails'}>
                                <TextArea
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} placeholder="Nhập người nhận thông báo" size="large" />
                            </Form.Item>
                            <Form.Item valuePropName="checked" name={'sendingNotification'}>
                                <Checkbox
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}>Gửi thông báo đến người nhận</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={7}>
                            <Form.Item label="Phân quyền truy cập" name={'accessIds'}>
                                <Select
                                    filterOption={filterOption}
                                    allowClear
                                    showSearch
                                    mode='multiple'
                                    size="large"
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly}
                                    options={employeeList.map(x => {
                                        return {
                                            label: x.name,
                                            value: x.id,
                                        };
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={1} />
                        <Col md={8}>
                            <Form.Item label="Tag" name={'tags'}>
                                <TextArea
                                    disabled={(!isNew && planPeriodType === PlantPeriodType.Quarter) || isReadOnly} placeholder="Nhập tag" size="large" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Row className="action mt-3" justify="end">
                            {isNew && (
                                <Col>
                                    <Button className="green" onClick={handleNextKr} disabled={updatingQuantitative}>
                                        Lưu & Tạo KR khác
                                    </Button>
                                </Col>
                            )}
                            <Col>
                                <Button
                                    className="secondary"
                                    onClick={() => {
                                        handleClose();
                                    }}
                                    disabled={updatingQuantitative}
                                >
                                    Hủy
                                </Button>
                            </Col>
                            <Col>
                                <Button className="primary" htmlType="submit" disabled={updatingQuantitative || isReadOnly}>
                                    Lưu
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </Container>
            {isOpenModalFormObjective && (
                <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={id ?? idObjective} onClose={handleCloseModelObjective} />
            )}
            {isOpenModal &&
                <ObjectiveKRRowSelection defaultSelected={[]} isOpen={isOpenModal} onClose={handleCloseModal} />
            }
        </Spin>
    );
};

export default CopyKRQuantitative;

